import { put, takeEvery } from "redux-saga/effects";
import { Project } from "../../models/project";
import { ErrorResponse } from "../../models/store";
import {
    GetAllProjectList,
    GetAllProjectListComplete,
    UpdateProject,
    UpdateProjectComplete,
    UpdateProjectFailed,
    filterProjectList,
    filterProjectListComplete,
    AddVideoToProject,
    AddVideoToProjectComplete,
} from "../actions/ExProjectActions";
import ProjectApi from "../apis/ExProjectApi";
import ProjectEvents from "../events/ExProjectEvents";

// プロジェクト一覧取得
function* GetAllProjects({ userId }: ReturnType<typeof GetAllProjectList>) {
    const projects: Project[] = yield ProjectApi.GetAllProjectList(userId);
    yield put(GetAllProjectListComplete(projects));
}
// プロジェクトフィルター
function* loadfilteredProjectList({ userId, filters }: ReturnType<typeof filterProjectList>) {
    const filterResult: Project[] = yield ProjectApi.GetProjectByProfessional(userId, filters);
    yield put(filterProjectListComplete(filterResult));
}
// プロジェクト一覧更新
function* UpdateProjectWorker({ userId, projectList }: ReturnType<typeof UpdateProject>) {
    const result: Project[] | ErrorResponse = yield ProjectApi.UpdateProject(userId, projectList);
    if (result instanceof ErrorResponse) {
        if (result.response && result.response.status !== 200) {
            yield put(UpdateProjectFailed(result.stack));
        }
    } else {
        yield put(UpdateProjectComplete(result));
    }
}
// プロジェクトにビデオ（エビソード・関連）を追加
function* AddVideoToProjectWorker({
    userId,
    projectId,
    videoId,
}: ReturnType<typeof AddVideoToProject>) {
    const project: Project = yield ProjectApi.AddVideoToProject(userId, projectId, videoId);
    yield put(AddVideoToProjectComplete(project));
}

export default function* ProjectSaga() {
    yield takeEvery(ProjectEvents.GetAllProjectListStarted, GetAllProjects);
    yield takeEvery(ProjectEvents.filterProjectListStart, loadfilteredProjectList);
    yield takeEvery(ProjectEvents.UpdateProjectStarted, UpdateProjectWorker);
    yield takeEvery(ProjectEvents.AddVideoToProject, AddVideoToProjectWorker);
}
